module.exports = __webpack_public_path__ + "img/INTERIOR-SWIFT-SPORT-2.51175cfa.jpg";